import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import { emptyFn } from '../../utils/helper';
import Item from './Item';
import { decideKeepDom } from '../../utils/keepDom';
import { consumeTheme } from '../../utils/theme';
import { PreventScrollPenetrateContainer } from '../../utils/preventScrollPenetrate';
import { i18n } from '../../common/locale';
import Button from '../Button';
export var ACTION_SHEET_TRANSITION_DURATION = 200;
var ActionSheet = (function (_super) {
    __extends(ActionSheet, _super);
    function ActionSheet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a, _b, _c;
            var _d = _this.props, prefixCls = _d.prefixCls, className = _d.className, style = _d.style, visible = _d.visible, onCancel = _d.onCancel, containerStyle = _d.containerStyle, zIndex = _d.zIndex, testId = _d.testId, type = _d.type, mask = _d.mask, preventScrollPenetrate = _d.preventScrollPenetrate, onClickMask = _d.onClickMask;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-hidden"] = !visible,
                _a));
            var maskClasses = classNames(prefixCls + "-mask", (_b = {},
                _b[prefixCls + "-mask-hidden"] = !visible,
                _b));
            var containerClasses = classNames(prefixCls + "-container", (_c = {},
                _c[prefixCls + "-container-no-mask"] = !mask,
                _c));
            if (!decideKeepDom.call(_this, ACTION_SHEET_TRANSITION_DURATION, visible)) {
                return null;
            }
            return ReactDOM.createPortal(h(PreventScrollPenetrateContainer, { disabled: typeof preventScrollPenetrate === 'boolean' ? !preventScrollPenetrate : !mask, className: containerClasses, style: __assign({ zIndex: zIndex }, containerStyle) },
                mask && h("div", { className: maskClasses, onClick: onClickMask || onCancel }),
                h(PreventScrollPenetrateContainer, { disabled: typeof preventScrollPenetrate === 'boolean' ? !preventScrollPenetrate : mask, className: classes, style: style, "data-testid": testId }, type === 'basic'
                    ? _this.renderBasicPanelContent(classNames)
                    : _this.renderComplexPanelContent(classNames))), document.body);
        };
        return _this;
    }
    ActionSheet.prototype.handleClickAction = function (id, callback) {
        callback === null || callback === void 0 ? void 0 : callback(id);
        this.props.onClickAction(id);
    };
    ActionSheet.prototype.renderBasicPanelContent = function (classNames) {
        var _this = this;
        var _a = this.props, prefixCls = _a.prefixCls, options = _a.options, cancelText = _a.cancelText, selectedIds = _a.selectedIds, onCancel = _a.onCancel, title = _a.title;
        return (h(React.Fragment, null,
            h("div", { className: classNames(prefixCls + "-options") },
                typeof title === 'string' && h(Item, { id: title, className: classNames(prefixCls + "-option-title"), disabled: true }),
                options.map(function (o) {
                    return h(Item, __assign({}, o, { key: o.id, selected: selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.includes(o.id), selectable: Boolean(selectedIds), onClick: function (id) { return _this.handleClickAction(id, o.onClick); } }));
                })),
            h(Item, { title: cancelText, onClick: onCancel, className: classNames(prefixCls + "-cancel") })));
    };
    ActionSheet.prototype.renderComplexPanelContent = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, onCancel = _a.onCancel, title = _a.title, headerAction = _a.headerAction, content = _a.content, onClickHeaderAction = _a.onClickHeaderAction, primaryAction = _a.primaryAction, onClickPrimaryAction = _a.onClickPrimaryAction, secondaryAction = _a.secondaryAction, onClickSecondaryAction = _a.onClickSecondaryAction, headerClassName = _a.headerClassName, headerStyle = _a.headerStyle, footerClassName = _a.footerClassName, footerStyle = _a.footerStyle, closeClassName = _a.closeClassName, closeStyle = _a.closeStyle, contentClassName = _a.contentClassName, contentStyle = _a.contentStyle;
        return (h(React.Fragment, null,
            h("div", { className: classNames(prefixCls + "-header", headerClassName), style: headerStyle },
                headerAction && h("div", { className: classNames(prefixCls + "-header-action"), onClick: onClickHeaderAction }, headerAction),
                title && h("div", { className: classNames(prefixCls + "-header-title") }, title),
                h("div", { className: classNames(prefixCls + "-header-close", closeClassName), style: closeStyle, onClick: onCancel })),
            h("div", { className: classNames(prefixCls + "-content", contentClassName), style: contentStyle }, content),
            primaryAction && h("div", { className: classNames(prefixCls + "-footer", footerClassName), style: footerStyle },
                h("div", { className: classNames(prefixCls + "-footer-primary-action"), onClick: onClickPrimaryAction }, typeof primaryAction === 'string'
                    ? h(Button, { type: "primary", size: "large" }, primaryAction)
                    : primaryAction),
                secondaryAction &&
                    h("div", { className: classNames(prefixCls + "-footer-secondary-action"), onClick: onClickSecondaryAction }, secondaryAction))));
    };
    ActionSheet.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return ActionSheet;
}(React.Component));
export default ActionSheet;
ActionSheet.defaultProps = {
    prefixCls: 'dui-m-actionsheet',
    onClickAction: emptyFn,
    onCancel: emptyFn,
    options: [],
    cancelText: i18n('cancel'),
    type: 'basic',
    mask: true,
};
